<mat-card>
<mcrit-gestio-manage-proposal-data
  [showAsyncProgress]="showAsyncProgress"
  [isNew]="(id === 'new')"
  [data]="projectInformation"
  (requestChange)="dataChangeRequested($event)">
</mcrit-gestio-manage-proposal-data>
<mcrit-gestio-document class="equiWColElement"
  [tipus]="'proposals'"
  [codi]="id">
</mcrit-gestio-document>
<mcrit-gestio-manage-project-clients-socis-list style="float:left;clear:both;width:100%"
  [showAsyncProgress]="showAsyncProgress"
  [clientsSocisList]="projectProposalClients"
  [idProjecte]="id"
  [routekey]="'proposal'"
  [tipus]="'Clients'"
  (changeClientSoci)="changeClientContacteProposal($event)"
  (deleteClientSoci)="deleteClientContacteProposal($event)"
   class="equiWColElement">
</mcrit-gestio-manage-project-clients-socis-list>
<mcrit-gestio-manage-project-clients-socis-list style="float:left;clear:both;width:100%"
  [showAsyncProgress]="showAsyncProgress"
  [clientsSocisList]="projectProposalSocis"
  [idProjecte]="id"
  [routekey]="'proposal'"
  [tipus]="'Socis'"
  (changeClientSoci)="changeSociContacteProposal($event)"
  (deleteClientSoci)="deleteSociContacteProposal($event)"
   class="equiWColElement">
</mcrit-gestio-manage-project-clients-socis-list>
<mcrit-gestio-manage-project-collaborator-list style="float:left;clear:both;width:100%"
  [showAsyncProgress]="showAsyncProgress"
  [collaboratorList]="projectCollaborators"
  [idProjecte]=""
  [idProposal]="id"
  (changeCollaborator)="changeCollaborator($event)"
   class="equiWColElement">
</mcrit-gestio-manage-project-collaborator-list>
</mat-card>
<!-- template syntax angular2 -->
<mat-card *ngIf="error" class="error" style="float:left;clear:both;visibility:hidden">
  <mat-card-title align="center">Error {{error.status}}</mat-card-title>
  <mat-card-subtitle align="center">{{error.statusText}}</mat-card-subtitle>
  <mat-card-content align="center">
    <p>{{error.msg}}</p>
  </mat-card-content>
</mat-card>